import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

export default class GTMDetailContactLandlordButtonClickModel extends GTMBaseModel {
    public static parseToGTMData(): GTMEventReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'detail_contact_landlord_button_click'
        };
    }
}
